<template>
    <div>
        <!-- Status -->
        <sau-service-status :service="service"></sau-service-status>

        <!-- Node List -->
        <div v-if="nodes.length > 0">
            <div class="row pt-6">
                <div class="col">
                    <h3>Nodes</h3>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="sau-bx bx-pad">
                        <table class="sau-bx-table sau-font sm">
                            <tbody>
                                <tr v-for="node in nodes" :key="node.id">
                                    <td width="40" class="py-2"><i class="fal fa-code-merge p-2" style="font-size:29px;"></i></td>
                                    <td>{{node.domain}}</td>
                                    <td>{{node.location}}</td>
                                    <!-- <td align="right"><a :href="nodeLink(node)" class="sau-link-button sm">View node</a></td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>


        <!-- System Details -->
        <sau-service-common-system :service="service" class="pt-6"></sau-service-common-system>

        <!-- Bandwidth Graph -->
        <sau-bandwidth-graph  v-if="showBandwidth && checked" class="pt-6" :service="service"></sau-bandwidth-graph>
    </div>
</template>

<script>
export default {
    props: ['service'],
    data() {
        return {
            nodes: [
                {domain:'Zone 1 node 1', location:'Sydney', id:'2', type:'dedicated-server'},
                {domain:'Zone 1 node 2', location:'Sydney', id:'2', type:'dedicated-server'},
                {domain:'Zone 1 node 3', location:'Sydney', id:'2', type:'dedicated-server'},
                {domain:'Zone 2 node 1', location:'Melbourne', id:'2', type:'dedicated-server'}
            ],
        }
    },
    created() {
        // Lock down functionality if the service is suspended
        if(this.service.status.toLowerCase() != 'suspended') {
            this.startApp();
        }
    },
    methods: {
        startApp() {
            this.getHadraasInfo().then(response => {
                if(response.data.status == 'success') {
                    //this.nodes = response.data.data;
                }
            }).catch(error => {
                console.log('error', error);
            });
        },
        nodeLink(node) {
            return '/services/' + node.type + '/' + node.id + '/summary';
        }
    },
    computed: {
    }
}
</script>
